import { WalletStateInterface } from "./types"; 
import VuetifySelectItems from '@/types/app/vuetifySelectItems';
export default {
 
  getSelectProductsState(state: WalletStateInterface): VuetifySelectItems[] {
    return state.selectProducts;
  },
  getSelectFundsState(state: WalletStateInterface): VuetifySelectItems[] {
    return state.selectFunds;
  },
};
